import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';

const routes: Routes = [{ path: 'unauthorized', component: UnauthorizedComponent }]; // sets up routes constant where you define your routes

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthGmsRoutingModule {}
